import { getNestedPropertyOrDefault } from 'style-utils/core/createExtractCssFromProps/utils/getNestedPropertyOrDefault';
import {
  ExtractCssFromPropsFn,
  Property,
  StyledPropType,
} from '../../core.types';
import { CSSObject } from 'styled-components';

export const createStyleFunction = ({
  properties,
  property,
  themeKey,
  transform: transformPropValueToCssRule = getPropValue,
  defaultScale,
}: Property) => {
  //if we didn't passed the properties, we put the single property in an array
  const propertiesToMap = properties || [property];

  const extractCssFromProps: ExtractCssFromPropsFn = (value, scale, _props) => {
    const resultCssObject: CSSObject = {};
    const cssMappedProperty = transformPropValueToCssRule(value, scale, _props);
    if (cssMappedProperty == null) return;
    propertiesToMap.forEach((prop) => {
      resultCssObject[prop] = cssMappedProperty;
    });
    return resultCssObject;
  };

  //we add the themeKey and the defaultScale to the function so we can use them in the parser
  extractCssFromProps.scale = themeKey || property || '';
  extractCssFromProps.defaults = defaultScale;

  return extractCssFromProps;
};

//this is the default function used to transform the value of the prop to the css value
const getPropValue = (propValue: StyledPropType, scale: object) =>
  getNestedPropertyOrDefault(scale, propValue, propValue);
